<template>
  <v-parallax
    src="@/assets/background.svg"
    height="inherit"
  >
    <div
      class="
        my-4
        mx-md-5 mx-lg-10 mx-xl-10
        ma-md-5 ma-lg-10 ma-xl-10
        pa-2
        pt-md-0
        px-md-4
        mt-md-0 mt-4
        maxw-1750
      "
    >
      <v-row align="center" justify="start">
        <v-col cols="1"></v-col>
        <v-col cols="2">
          <v-img
            alt="Movil"
            class="mr-2 mt-10"
            contain
            src="@/assets/appLogOutBordeless.png"
            transition="scale-transition"
            width="350"
          />
        </v-col>
        <v-col>
          <div class="text-center">
            <h1 v-show="showSessionExpired" :style="{marginBottom: '3rem'}">
              {{ $t('views.announcementapp.sessionExpired') }}
            </h1>
            <h1>{{ this.$t("views.announcementapp.title") }}</h1>
            <h2 class="text--normal">{{ this.$t("views.announcementapp.subtitleTop") }}</h2>
            <h2 class="text--normal">{{ this.$t("views.announcementapp.subtitleBottom") }}</h2>
            <v-row class="ml-6" :style="{gap:'1rem', justifyContent:'center'}">
              <v-col :style="{maxWidth:'fit-content'}">
                <div class="container__badge">
                  <img
                    alt="QR Android"
                    src="@/assets/QR_PlayStore.jpg"
                    contain
                    width="180"
                    position="rigth fixed"
                  />
                </div>
                <img
                  alt="Android"
                  src="@/assets/logo_badge_googlePlay.png"
                  contain
                  width="180"
                  position="rigth fixed"
                  class ="imagebadge"
                  @click="onClickImage('android')"
                />
              </v-col>
              <v-col :style="{maxWidth:'fit-content'}">
                <div class="container__badge">
                  <img
                    alt="QR IOS"
                    src="@/assets/QR_AppStore.png"
                    contain
                    width="180"
                    position="rigth fixed"
                  />
                </div>
                <img
                  alt="iOS"
                  src="@/assets/logo_badge_appStore.png"
                  contain
                  width="180"
                  position="left fixed"
                  class ="imagebadge"
                  @click="onClickImage('ios')"
                />
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </div>
  </v-parallax>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'AnnouncementApp',
  data() {
    return {
      showSessionExpired: false,
      urls: {
        android:
        'https://play.google.com/store/apps/details?id=es.juntadeandalucia.msspa.ayudadigital',
        ios:
        'https://apps.apple.com/es/app/ayudadigital/id1531469960',
      },

    };
  },
  beforeCreate() {
    if (!this.$vuetify.breakpoint.mdAndUp) {
      this.$router.push({ name: 'Login' });
    }
  },
  computed: {
    ...mapGetters({
      isSignedIn: 'session/isSignedIn',
    }),
  },
  methods: {
    onClickImage(url) {
      window.open(this.urls[url], '_blank');
    },
  },
  mounted() {
    this.showSessionExpired = JSON.parse(localStorage.getItem('sessionExpired'));
  },
};
</script>

<style>
  .imagebadge {
    cursor: pointer;
    margin: 0 1rem;
  }
  .container__badge {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 3rem 0;
  }
  .text--normal {
    font-weight: 500;
  }
</style>
